import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';

// Auth Components
import Login from './auth/Login';
import Register from './auth/Register';

// Layout Components
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

// Pump Modules
import Dashboard from './pump/Dashboard';
import Nozzlemaster from './pump/Nozzlemaster';
import Tankconfguration from './pump/Tankconfguration';
import Staffmgmt from './pump/Staffmgmt';
import Nozzlereading from './pump/Nozzlereading';
import Dipentry from './pump/Dipentry';
import Dailydenomination from './pump/Dailydenomination';
import Pumpdetails from './pump/Pumpdetails';
import Paymentmode from './pump/Paymentmode';
import Creditcustomers from './pump/Creditcustomers';
import Customerledger from './pump/Customerledger';
import Lubricantsinventory from './pump/Lubricantsinventory';
import Vendormgmt from './pump/Vendormgmt';
import Purchaseentry from './pump/Purchaseentry';
import Vendoraccoount from './pump/Vendoraccoount';
import Saleentry from './pump/Saleentry';
import Expensehead from './pump/Expensehead';
import Dailyexpense from './pump/Dailyexpense';
import Dsrreport from './pump/Dsrreport';
import Variationreport from './pump/Variationreport';
import Salepurchase from './pump/Salepurchase';
import Headwisereport from './pump/Headwisereport';
import Purchasestock from './pump/Purchasestock';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // onAuthStateChanged returns an unsubscribe function
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  // Show a blank screen or spinner while checking auth status
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-orange" role="status"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="wrapper">
        {
          !user ? (
            /* PUBLIC ROUTES */
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='/register' element={<Register />} />
              <Route path='*' element={<Navigate to="/login" />} />
            </Routes>
          ) : (
            /* PRIVATE ROUTES */
            <>
              <Header />
              <Menu />

              <Routes>
                <Route path='/purchase-stock' element={<Purchasestock />} />
                <Route path='/headwise-report' element={<Headwisereport />} />
                <Route path='/sale-purchase-report' element={<Salepurchase />} />
                <Route path='/variation-report' element={<Variationreport />} />
                <Route path='/dsr-report' element={<Dsrreport />} />
                <Route path='/pump-expenses' element={<Dailyexpense />} />
                <Route path='/expense-heads' element={<Expensehead />} />
                <Route path='/sale-entry' element={<Saleentry />} />
                <Route path='/vendors-account' element={<Vendoraccoount />} />
                <Route path='/purchase-entry' element={<Purchaseentry />} />
                <Route path='/vendors-mgmt' element={<Vendormgmt />} />
                <Route path='/lubricants-inventory' element={<Lubricantsinventory />} />
                <Route path='/customer-ledger' element={<Customerledger />} />
                <Route path='/credit-customers' element={<Creditcustomers />} />
                <Route path='/payment-modes' element={<Paymentmode />} />
                <Route path='/' element={<Dashboard />} />
                <Route path='/home' element={<Dashboard />} />
                <Route path='/pump-details' element={<Pumpdetails />} />
                <Route path='/tank-master' element={<Tankconfguration />} />
                <Route path='/nozzle-master' element={<Nozzlemaster />} />
                <Route path='/staff-mgmt' element={<Staffmgmt />} />
                <Route path='/nozzle-readings' element={<Nozzlereading />} />
                <Route path='/daily-dip-entry' element={<Dipentry />} />
                <Route path='/daily-denomination' element={<Dailydenomination />} />
                <Route path='/make-payment' element={<MakePayment />} />
                {/* <Route path='*' element={<Navigate to="/" />} /> */}
              </Routes>

              <Footer />
            </>
          )
        }
      </div>
    </Router>
  );
}


// Placeholder for Payment Page
const MakePayment = () => {
  const handleCall = () => {
    window.location.href = "tel:8459432930";
  };

  return (
    <div className="content-wrapper d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div className="col-md-6">
        <div className="card card-outline card-danger shadow-lg text-center p-4">
          <div className="card-body">
            <div className="mb-4">
              <i className="fas fa-exclamation-triangle text-danger fa-4x mb-3"></i>
              <h1 className="display-5 font-weight-bold">Account Inactive</h1>
              <p className="lead text-muted">
                Your annual subscription has expired. Please complete the payment to restore access to your petrol pump management tools.
              </p>
            </div>

            <hr />

            <div className="my-4">
              <h5 className="text-uppercase text-secondary mb-3">Support & Billing Contact</h5>
              <div className="bg-light p-3 rounded">
                <h4 className="mb-1 font-weight-bold">Rohan Thorat</h4>
                <p className="mb-2 text-primary" style={{ fontSize: '1.2rem' }}>
                  <i className="fas fa-phone-alt mr-2"></i> +91 8459432930
                </p>
                <button onClick={handleCall} className="btn btn-outline-primary btn-sm">
                  Click to Call
                </button>
              </div>
            </div>

            <div className="mt-4">
              <button className="btn btn-success btn-lg btn-block shadow-sm">
                <i className="fas fa-credit-card mr-2"></i> PROCEED TO ONLINE PAYMENT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;